import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from '../../models/api-resource.interface';
import { CommunicationMessageType } from './communication-message-type.interface';
export class CommunicationMessageTypeService {
   async getCommunicationMessageTypes(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<CommunicationMessageType>>>(`/communication-message-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getCommunicationMessageType() {
      throw Error('Method not implemented');
   }

   async postCommunicationMessageType() {
      throw Error('Method not implemented');
   }

   async putCommunicationMessageType() {
      throw Error('Method not implemented');
   }

   async deleteCommunicationMessageType() {
      throw Error('Method not implemented');
   }
}
